import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UITable from 'UIComponents/table/UITable';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { formatNumberForEnrollmentConversionReporting, formatPercentageForEnrollmentConversionReporting } from 'automation-ui-canvas/containers/enrollment-conversion/enrollmentConversionUtils';
import EnrollmentConversionPanelSummaryRow from 'automation-ui-canvas/containers/enrollment-conversion/panel/table/EnrollmentConversionPanelSummaryRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
//Note: this count will always be 0 as we do not get any error information from the reporting service
const ENROLLMENT_ERROR_COUNT = 0;
const ENROLLMENT_PERCENTAGE_FOR_ENROLLMENT_CARD = 100;
const ConversionSummaryEnrollmentRow = ({
  isReportingEnabled,
  enrollmentConversionData
}) => {
  var _conversionReport$tot, _conversionReport$tot2, _conversionReport$tot3;
  const conversionReport = enrollmentConversionData === null || enrollmentConversionData === void 0 ? void 0 : enrollmentConversionData.conversionReport;
  return /*#__PURE__*/_jsx(UITooltip, {
    title: isReportingEnabled ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation.enrollmentConversion.panel.tooltips.summary",
      options: {
        completedPercentage: formatPercentageForEnrollmentConversionReporting(ENROLLMENT_PERCENTAGE_FOR_ENROLLMENT_CARD),
        totalEnrollments: formatNumberForEnrollmentConversionReporting((_conversionReport$tot = conversionReport === null || conversionReport === void 0 ? void 0 : conversionReport.totalEnrollmentCount) !== null && _conversionReport$tot !== void 0 ? _conversionReport$tot : 0),
        errorPercentage: ENROLLMENT_ERROR_COUNT,
        reachedEnrollments: formatNumberForEnrollmentConversionReporting((_conversionReport$tot2 = conversionReport === null || conversionReport === void 0 ? void 0 : conversionReport.totalEnrollmentCount) !== null && _conversionReport$tot2 !== void 0 ? _conversionReport$tot2 : 0)
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.enrollmentConversion.panel.summaryTable.defaultState.tooltip"
    }),
    children: /*#__PURE__*/_jsxs("tr", {
      children: [/*#__PURE__*/_jsx("td", {
        children: /*#__PURE__*/_jsx(UITruncateString, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.enrollmentConversion.panel.summaryTable.Enrollments"
          })
        })
      }), /*#__PURE__*/_jsx("td", {
        className: "text-right",
        children: isReportingEnabled ? formatNumberForEnrollmentConversionReporting((_conversionReport$tot3 = conversionReport === null || conversionReport === void 0 ? void 0 : conversionReport.totalEnrollmentCount) !== null && _conversionReport$tot3 !== void 0 ? _conversionReport$tot3 : 0) : /*#__PURE__*/_jsx(UITruncateString, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.enrollmentConversion.panel.summaryTable.defaultState.count"
          })
        })
      }), /*#__PURE__*/_jsx("td", {
        className: "text-right",
        children: isReportingEnabled ? ENROLLMENT_ERROR_COUNT : /*#__PURE__*/_jsx(UITruncateString, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.enrollmentConversion.panel.summaryTable.defaultState.count"
          })
        })
      })]
    })
  });
};
const EnrollmentConversionPanelSummaryContent = ({
  orderedActions,
  isReportingEnabled,
  getHeaderTitle,
  currentVersionGroupFlow,
  enrollmentConversionData
}) => {
  return /*#__PURE__*/_jsxs(UITable, {
    style: {
      borderBottom: 'none'
    },
    children: [/*#__PURE__*/_jsxs("colgroup", {
      children: [/*#__PURE__*/_jsx("col", {
        style: {
          width: '60%'
        }
      }), /*#__PURE__*/_jsx("col", {
        style: {
          width: '20%'
        }
      }), /*#__PURE__*/_jsx("col", {
        style: {
          width: '20%'
        }
      })]
    }), /*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsx(UITooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.enrollmentConversion.panel.tooltips.summaryHeader"
        }),
        children: /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation.enrollmentConversion.panel.summaryTable.steps"
            })
          }), /*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation.enrollmentConversion.panel.summaryTable.completed"
            })
          }), /*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation.enrollmentConversion.panel.summaryTable.errors"
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsxs("tbody", {
      children: [/*#__PURE__*/_jsx(ConversionSummaryEnrollmentRow, {
        isReportingEnabled: isReportingEnabled,
        enrollmentConversionData: enrollmentConversionData
      }), orderedActions.map(action => /*#__PURE__*/_jsx(EnrollmentConversionPanelSummaryRow, {
        action: action,
        enrollmentConversionData: enrollmentConversionData,
        flow: currentVersionGroupFlow,
        getHeaderTitle: getHeaderTitle,
        isReportingEnabled: isReportingEnabled
      }, action.actionId))]
    })]
  });
};
export default EnrollmentConversionPanelSummaryContent;